import { useEffect } from "react";

type Props = {
  title: string;
};

export default function Title({ title }: Props) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
